import { CSSProperties } from "react";

const CrossIcon = ({
  scale,
  color,
  bgColor,
  style,
}: {
  scale?: number;
  color?: string;
  bgColor?: string;
  style?: CSSProperties;
}) => {
  let c = "#1062D0";
  let bg = "#EBEFF5";
  if (color) c = color;
  if (bgColor) bg = bgColor;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})`, ...style }}
    >
      <rect width="24" height="24" rx="3" fill={bg} />
      <path
        d="M17.3334 17.3333L6.66669 6.66666M17.3334 6.66666L6.66669 17.3333"
        stroke={c}
        strokeWidth="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CrossIcon;
